var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var DefaultGrid = /** @class */ (function (_super) {
    __extends(DefaultGrid, _super);
    function DefaultGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultGrid.prototype.render = function () {
        if (React.Children.count(this.props.children) == 2) {
            return React.createElement("div", { className: "default-grid" },
                React.createElement("div", { className: "first" }, React.Children.toArray(this.props.children)[0]),
                React.createElement("div", { className: "second" }, React.Children.toArray(this.props.children)[1]));
        }
        return null;
    };
    return DefaultGrid;
}(React.Component));
export default DefaultGrid;
//# sourceMappingURL=DefaultGrid.js.map


//////////////////
// WEBPACK FOOTER
// ./bpm-web-generic/lib/components/DefaultGrid.js
// module id = 1165
// module chunks = 0